<template>
    <v-form-group class="video-field"
                  :label="label"
                  :description="description"
                  :error="error"
                  :state="errorState">
        <b-input
            :value="input"
            @input="handleInput"
            :readonly="readonly"
            :state="errorState"/>
        <template slot="below">
            <v-video-embed v-if="input"
                           :src="input"/>
        </template>
    </v-form-group>
</template>

<script>
    import field from "../../Mixins/field"

    export default {
        mixins: [field]
    }
</script>